import classNames from 'classnames';
import { useEffect, useRef } from 'react';
import scrollIntoView from 'scroll-into-view-if-needed';

import { LineGroup, LiveBlockAddress } from '../types';
import { LineView } from './LineView';
import { LineGroupWrapper } from './wrappers';

type LineGroupProps = {
  lineGroup: LineGroup,
  liveAddress?: LiveBlockAddress,
  onLineClick?: (lineIdx: number) => void
};

export const LineGroupView = ({ lineGroup, liveAddress, onLineClick }: LineGroupProps) => {

  const ref = useRef<HTMLDivElement>(null);

  const classes = classNames(
    {
      'bg-blue-200': !!liveAddress
    }
  );

  useEffect(
    () => {
      if (liveAddress && ref.current) {
        if (liveAddress.wasClicked) {
          scrollIntoView(ref.current, { block: 'end', scrollMode: 'if-needed' });
        }
        else {
          ref.current.scrollIntoView({ block: 'end' });
        }
      }
    },
    [liveAddress]
  );

  return (
    <LineGroupWrapper
      className={classes}
      ref={ref}
    >
      {
        lineGroup.map(
          (line, idx) => (
            <LineView
              key={idx}
              line={line}
              onClick={() => onLineClick && onLineClick(idx)}
            />
          )
        )
      }
    </LineGroupWrapper>
  );
};
